import * as React from 'react';

import classNames from 'classnames';

import { EAppPicSize, EResponseStatus } from '@enums';

import { updateLinkParams } from '@utils';

import { ITranslatable, Translate, TranslateFn } from '@decorators';

import { IShowcase } from '@stores/ShowcaseStore';

import { AppItem, EAppItemType, IAppItem } from '@components';

import { IAppData } from '@interfaces';

import { IAppsListProps } from './types';

import * as s from './AppsList.scss';

@Translate('components.AppsCatalog.AppsList')
export class AppsList extends React.PureComponent<IAppsListProps> implements ITranslatable {

	declare t: TranslateFn;

	static defaultProps = {
		apps: [] as IAppData[],
	};

	renderError = (errorMessage: string) => {
		return (
			<div className={classNames(s.errorMessage)}>
				<span>
					{errorMessage}
				</span>
			</div>
		);
	};

	renderApps = (props: Omit<IAppsListProps, 'renderCustomAppsList'>) => {
		const {
			apps,
			appItemClassName,
			appsLimitToRender,
			imageType,
			type,
			urlRef,
			responseStatus,
			...itemProps
		} = props;
		const appItemsData = apps.length
			? apps
			: new Array(appsLimitToRender || 10).fill(null);
		const MAP_TYPE_TO_PIC = {
			[EAppItemType.SMALL]: EAppPicSize.PIC_143_113,
			[EAppItemType.MEDIUM]: EAppPicSize.PIC_143_113,
			[EAppItemType.WIDE]: EAppPicSize.PIC_560_210,
			[EAppItemType.HORIZONTAL]: EAppPicSize.PIC_143_113,
			[EAppItemType.LARGE]: EAppPicSize.PIC_753_423,
		};

		return appItemsData
			.map((appData: IAppData | IShowcase | undefined, i: number) => {
				const app = appData || null;
				const appItem: IAppItem = {
					...app,
					url: app?.url
						? updateLinkParams(app?.url, { ref: urlRef })
						: undefined,
					isFake: responseStatus === EResponseStatus.PENDING || !app,
					title: app?.title || '',
					id: app?.id || `fakeId_${i}`,
					image: imageType
						? app?.pics?.[imageType]
						: app?.pics?.[MAP_TYPE_TO_PIC?.[type]] ||
						'',
					description: app && 'descriptionShort' in app ? app?.descriptionShort : app?.description,
				};

				return <AppItem
					key={`appItem_${appItem.id}`}
					app={appItem}
					className={appItemClassName}
					type={type}
					{...itemProps}
				/>;
			});
	};

	render() {
		const {
			apps,
			responseStatus,
			renderCustomAppsList,
			...rest
		} = this.props;
		const appsList = this.renderApps({ apps, responseStatus, ...rest });
		const isNoGamesToShow = responseStatus === EResponseStatus.ERROR && !apps?.length;

		if (isNoGamesToShow) {
			return this.renderError(this.t('empty'));
		}

		if (renderCustomAppsList) {
			return renderCustomAppsList(appsList);
		} else {
			return appsList;
		}
	}

}
